import { EnvironmentProviders } from '@angular/core';
import * as authEffects from './auth.effects';
import { authReducer } from './auth.reducer';
import { authKey } from './auth.state';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

export function provideAuthStore(): EnvironmentProviders[] {
  return [provideState({ name: authKey, reducer: authReducer }), provideEffects(authEffects)];
}
